import { render } from "./InfoSectionView.vue?vue&type=template&id=83518174&scoped=true"
import script from "./InfoSectionView.vue?vue&type=script&lang=js"
export * from "./InfoSectionView.vue?vue&type=script&lang=js"

import "./InfoSectionView.vue?vue&type=style&index=0&id=83518174&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83518174"]])

export default __exports__